
import { Options, Vue } from 'vue-class-component';
import { Course, CourseEnrollment } from "@/data/course";
import { CourseMode } from "@/data/enums";
import NavigationService from "@/services/NavigationService";
import CourseEnrollmentModal from "@/components/modals/CourseEnrollmentModal.vue";
import CourseAppointmentsModal from "@/components/modals/CourseAppointmentsModal.vue";

@Options({
    props: {
        course: {
            type: Object,
            required: true,
        },
        userCourseEnrollments: {
            type: Array,
            required: false,
            default: [],
        },
        closeModalOnEnrollmentChange: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    components: {
        CourseAppointmentsModal,
        CourseEnrollmentModal,
    },
    watch: {

    },
    emits: [
        'enrollmentStatusChange',
    ]
})
export default class CourseActions extends Vue {
    course!: Course
    userCourseEnrollments!: CourseEnrollment[]
    closeModalOnEnrollmentChange!: boolean

    loading = false

    enrollmentModalShown = false

    appointmentsModalShown = false

    get CourseMode() { // @TODO: refactor enum usage
        return CourseMode;
    }

    getRegisterUrl(course: Course) {
        return NavigationService.buildRouteUrl('register', { region: course.region_id, course: course.id });
    }

    get enrollment(): CourseEnrollment|undefined {
        return this.userCourseEnrollments.find(enrollment => {
            return enrollment.course_id === this.course.id;
        });
    }

    onEnrollmentStatusChange() {
        this.$emit('enrollmentStatusChange');
        if( this.closeModalOnEnrollmentChange ) {
            this.enrollmentModalShown = false;
        }
    }

    //mounted() {}
}
